@ts-nocheck
<template>
  <div>
    <!-- Sidebar and Layout Components -->
    <LeftSidebar v-if="shouldShowSidebar && !isNotFound"/>
    <div class="container-fluid">
      <div class="main-content d-flex flex-column" :class="{ 'p-0': shouldShowPaddingZero || isNotFound }">
        <TopHeader v-if="shouldShowHeader && !isNotFound"/>
        <router-view/>
        <div class="flex-grow-1" v-if="shouldShowDiv && !isNotFound"></div>
        <MainFooter v-if="shouldShowFooter && !isNotFound"/>
      </div>
    </div>

    <!-- Modal Components -->
    <CreateTaskModal/>
    <AddNewLabelModal/>
    <AddNewCardModal/>
    <AddNewFileModal/>
    <AddNewOrderModal/>
    <AddNewCategorieModal/>
    <AddNewContactModal/>
    <AddNewCustomerModal/>
    <AddNewLeadModal/>
    <AddNewDealsModal/>
    <AddNewUserModal/>
    <AddNewInstructorsModal/>
    <SettingsSidebar/>

    <!-- Toast Container -->
    <div id="toast-container" class="position-fixed top-0 right-0 p-3" aria-live="polite" aria-atomic="true">
      <div
          v-for="(toast, index) in toasts"
          :key="index"
          class="toast show alert alert-info"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          @transitionend="removeToast(index)"
      >
        <div class="toast-body">{{ toast.message }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck

import {defineComponent, ref, onMounted, computed} from "vue";
import {useRoute} from "vue-router";
import stateStore from "./utils/store";

// Import Layout and Modal Components
import LeftSidebar from "./components/Layouts/LeftSidebar.vue";
import TopHeader from "./components/Layouts/TopHeader/index.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";
import CreateTaskModal from "./components/Layouts/CreateTaskModal.vue";
import AddNewLabelModal from "./components/Layouts/AddNewLabelModal.vue";
import AddNewCardModal from "./components/Layouts/AddNewCardModal.vue";
import AddNewFileModal from "./components/Layouts/AddNewFileModal.vue";
import AddNewOrderModal from "./components/Layouts/AddNewOrderModal.vue";
import AddNewCategorieModal from "./components/Layouts/AddNewCategorieModal.vue";
import AddNewContactModal from "./components/Layouts/AddNewContactModal.vue";
import AddNewCustomerModal from "./components/Layouts/AddNewCustomerModal.vue";
import AddNewLeadModal from "./components/Layouts/AddNewLeadModal.vue";
import AddNewDealsModal from "./components/Layouts/AddNewDealsModal.vue";
import AddNewUserModal from "./components/Layouts/AddNewUserModal.vue";
import AddNewInstructorsModal from "./components/Layouts/AddNewInstructorsModal.vue";
import SettingsSidebar from "./components/Layouts/SettingsSidebar/index.vue";

// Import Echo instance (set up in echo.js)
import echo from './echo';

export default defineComponent({
  name: "App",
  components: {
    LeftSidebar,
    TopHeader,
    MainFooter,
    CreateTaskModal,
    AddNewLabelModal,
    AddNewCardModal,
    AddNewFileModal,
    AddNewOrderModal,
    AddNewCategorieModal,
    AddNewContactModal,
    AddNewCustomerModal,
    AddNewLeadModal,
    AddNewDealsModal,
    AddNewUserModal,
    AddNewInstructorsModal,
    SettingsSidebar,
  },
  setup() {
    const isLoading = ref(true);
    const route = useRoute();
    const toasts = ref<Array<{ message: string }>>([]);

    // Hide sidebar for specific routes
    const hiddenRoutes = [
      "/",
      "/features",
      "/our-team",
      "/faq",
      "/contact",
      "/authentication/login",
      "/legal/authentication/login",
      "/authentication/register",
      "/authentication/reset-password",
      "/authentication/forget-password",
      "/authentication/lock-screen",
      "/authentication/logout",
      "/legal/authentication/logout",
      "/authentication/confirm-mail",
      "/legal/sign/:id",
      "/legal/sign",
    ];

    const shouldShowSidebar = computed(() => !hiddenRoutes.includes(route.path));
    const shouldShowPaddingZero = computed(() => hiddenRoutes.includes(route.path));
    const shouldShowHeader = computed(() => !hiddenRoutes.includes(route.path));
    const shouldShowDiv = computed(() => !hiddenRoutes.includes(route.path));
    const shouldShowFooter = computed(() => !hiddenRoutes.includes(route.path));
    const isNotFound = computed(() => route.matched.some((record) => record.path === "/:pathMatch(.*)*"));

    // Show loading spinner initially
    onMounted(() => {
      setTimeout(() => {
        isLoading.value = false;
      }, 1000);

      // Set up Echo listener for the 'VacancyCreated' event
      echo.channel('vacancies')
          .listen('VacancyCreated', (event: any) => {
            showToast(event.message);
          });
    });

    const showToast = (message: string) => {
      toasts.value.push({message});
      setTimeout(() => {
        toasts.value.shift();
      }, 3000); // Remove toast after 3 seconds
    };

    const removeToast = (index: number) => {
      toasts.value.splice(index, 1);
    };

    return {
      isLoading,
      shouldShowSidebar,
      shouldShowPaddingZero,
      shouldShowHeader,
      shouldShowDiv,
      shouldShowFooter,
      isNotFound,
      toasts,
      showToast,
      removeToast,
    };
  },
});
</script>

<style lang="scss" scoped>
.padding-0 {
  .container-fluid {
    padding: 0;
  }
}

/* Toast Styles */
#toast-container {
  z-index: 1050;
  top: 20px;
  right: 20px;
}

.toast {
  max-width: 350px;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #605dff;
  color: white;
}

.toast-body {
  padding: 10px;
  font-size: 1rem;
}

.toast.show {
  opacity: 1;
}

.toast.hide {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
</style>
